export default "__VITE_ASSET__82e7ff5e__"